module.exports = {"620722101":"洪水镇","620722102":"六坝镇","620722103":"新天镇","620722104":"南古镇","620722105":"永固镇","620722106":"三堡镇","620722107":"南丰镇","620722108":"民联镇","620722109":"顺化镇","620722110":"丰乐镇","620722400":"民乐生态工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620722.json
// module id = 3059
// module chunks = 0